<template>
	<div class="wallet">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>我的钱包</span>
			<div></div>
		</div>
		<div class="head">
			<div class="total">
				<div class="active">
					<span class="total_span">总金额(元)</span>
					<span class="total_jiage">{{tixianlist.total}}</span>
				</div>
				<div>
					<div class="tixian">
						<i class="icon"></i>
						<span>提现</span>
					</div>
				</div>
			</div>
			<div class="balance">
				<div class="balance_1" style="border-right: 1px solid #fea451;">
					<span class="weniz">全部余额</span>
					<span class="shuliang">{{tixianlist.no_take}}</span>
				</div>
				<div class="balance_2">
					<span class="weniz">可提现余额</span>
					<span class="shuliang">{{tixianlist.user_money}}</span>
				</div>
			</div>
		</div>
		<div class="srjl serwme">
			<div class="stjl_s">
				<div>昨日收入(元)</div>
				<span>{{tixianlist.dayUserTotalLog}}</span>
			</div>
			<div class="stjl_s" @click="go(tixianlist.id)">
				<div style="color:red;">直接邀请人数</div>
				<span style="color:red;">{{tixianlist.user_share}}</span>
			</div>
			<div class="stjl_s">
				<div  >总线下人数</div>
				<span>{{tixianlist.user_total_share}}</span>
			</div>
		</div>
		<div class="srjl">收入记录</div>
		<div v-if="tixianlist.userTotalLog == 0" style="font-size: 13px; margin-top: 1rem;">
			您还没有收入记录，赶快分享吧！
		</div>
		<div class="source">
			<div class="sourceuser" v-for="(item,index) in tixianlist.userTotalLog" :ker="index">
				<img v-if="item.image!=''" :src="item.image" />
				<img v-else src="../../assets/user.png" />
				<div class="adress">
					<div>来自 <span>{{item.name}}</span> {{item.title}}</div>
					<div class="soan">{{item.create_time}}</div>
				</div>
				<span v-if="item.state == 1">+{{item.money}}</span>
				<span v-else style="color: #000000;">-{{item.money}}</span>
			</div>
		</div>
	</div>



</template>

<script>
	export default {
		data() {
			return {
				tixianlist: ""
			}
		},
		components: {

		},
		created() {
			this.getarr();
		},
		methods: {
			getarr() {
				let that = this
				this.$axios.post(baseUrl + '/mobile/userBalanceRecord/userBalance', {
					token: localStorage.getItem('Authorization'),
				}).then((res) => {
					that.tixianlist = res.data.data
				}).catch((err) => {
					console.log(err);
				})
			},
			go(e) {
				this.$router.push({
					path: '/directinvitation',
					query: {
						user_id: e
					}
				})
			},
		},
	}
</script>

<style scoped>
	@import "wallet.css";

	.wallet .head {
		width: 100%;
		background-image: url("https://backstage.jbj-china.com.cn/image/img/xinyebeijingtu.png");
		background-size: 100% 100%;
		color: #fff;
		padding-bottom: 0.8rem;
	}

	.wallet .serwme {
		display: flex;
		justify-content: space-between;
		width: 85%;
		margin: 0.7rem auto;
		text-align: center;
		border-radius: 0.3rem;
		padding: 0px 1rem;
	}

	.wallet .stjl_s span {
	 	font-size: 1rem;
		display: block;
	}

	.wallet .stjl_s div {
		font-size: 0.875rem;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/wallet.vue